// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  SharedGallery,
  SharedGalleriesListOptionalParams,
  SharedGalleriesGetOptionalParams,
  SharedGalleriesGetResponse,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a SharedGalleries. */
export interface SharedGalleries {
  /**
   * List shared galleries by subscription id or tenant id.
   * @param location The name of Azure region.
   * @param options The options parameters.
   */
  list(
    location: string,
    options?: SharedGalleriesListOptionalParams,
  ): PagedAsyncIterableIterator<SharedGallery>;
  /**
   * Get a shared gallery by subscription id or tenant id.
   * @param location The name of Azure region.
   * @param galleryUniqueName The unique name of the Shared Gallery.
   * @param options The options parameters.
   */
  get(
    location: string,
    galleryUniqueName: string,
    options?: SharedGalleriesGetOptionalParams,
  ): Promise<SharedGalleriesGetResponse>;
}
